import React, { useState } from 'react';
import { flCapital } from '../../helpers/Utils';

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
  
    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}

const ScreenshotControl = (props) => {

    return(
        <div>
            <div>
                <button style={{width:'100%', padding:'5px'}} onClick={() => props.screenshotcontrol()}>
                    <span role="img" aria-labelledby='Camera' style={{paddingLeft:'4px', paddingRight:'4px'}}>📷</span>
                </button>
            </div>
        </div>
    )
}

export default ScreenshotControl;